import { styled, css } from "styled-components";

export const Chip = styled.button<{ $active?: boolean }>`
  border: none;
  margin: 0;
  padding: ${(props) => `${props.theme.spacing.xs} ${props.theme.spacing.s}`};
  width: auto;
  overflow: visible;
  background: transparent;
  color: inherit;
  font: inherit;
  -webkit-font-smoothing: inherit;
  -moz-osx-font-smoothing: inherit;
  -webkit-appearance: none;
  border: 1.5px solid var(--swatch2);
  border-radius: 30px;
  white-space: nowrap;
  cursor: pointer;

  ${(props) =>
    props.$active &&
    css`
      background: var(--swatch1);
      color: #fff;
    `}
`;
